import { FC, PropsWithChildren } from "react";

interface AuthPageContainerProps extends PropsWithChildren {
    title?: string;
    maxWidth?: number;
}

export const AuthPageContainer: FC<AuthPageContainerProps> = ({ title, children, maxWidth = 430 }) => {
    return (
        <div className="flex flex-col items-center gap-10 w-full" style={{ maxWidth: 1260 }}>
            {title && (
                <h1
                    style={{
                        fontSize: 60,
                        color: "#171717",
                        fontWeight: 600,
                        margin: 0,
                        textAlign: "center",
                        lineHeight: 1.1,
                    }}
                >
                    {title}
                </h1>
            )}
            <div className="w-full" style={{ maxWidth }}>
                <div
                    className="bg-white w-full p-5 sm:p-8 rounded-[12px]"
                    style={{ border: "1px solid rgba(0,0,0,0.2)" }}
                >
                    {children}
                </div>
            </div>
        </div>
    );
};
